import { Filter } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export function TasksFilters({
  filter,
  setFilter,
  memberFilter,
  setMemberFilter,
  members,
}) {
  return (
    <div className="flex flex-wrap gap-3">
      <Select value={filter} onValueChange={setFilter}>
        <SelectTrigger
          className="w-[140px] bg-slate-900 border-slate-800"
          data-testid="filter-status"
        >
          <Filter size={16} className="mr-2" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Tasks</SelectItem>
          <SelectItem value="pending">Pending</SelectItem>
          <SelectItem value="completed">Completed</SelectItem>
        </SelectContent>
      </Select>

      <Select value={memberFilter} onValueChange={setMemberFilter}>
        <SelectTrigger
          className="w-[160px] bg-slate-900 border-slate-800"
          data-testid="filter-member"
        >
          <SelectValue placeholder="All Members" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Members</SelectItem>
          {members.map((member) => (
            <SelectItem key={member.id} value={member.id}>
              {member.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
